import moment from 'moment';
import _ from 'lodash';
import {
    initData, initCalendar, initFilters,
    initSnackbar, initPersonInfo, initDateRange,
    initPartialDates, initGlobalConfigs, initBuildInfos,
    initDismissData
} from './initValues';
import {
    mobileViewReducer, mobileOfferShiftFormReducer, mobileProposalShiftsReducer, mobilePaycodeFormReducer
} from './mobileReducers';
import { generateSelectedPartialLabel } from '../EmployeeDashboard/Utils/PartialShiftHelper';
import { RequestTypes } from '../../Enums';

const calendarReducer = (calendarDefinition = initCalendar, action) => {
    let newCalendar = Object.assign([], calendarDefinition);
    if (action.type === 'UPDATE_FILTERS_LIST') {
        newCalendar = Object.assign([], initCalendar, action.payload.calendarDefinition.concat(action.payload.availableCalendarDefinition))
    }
    return newCalendar;
}

const filtersReducer = (filters = initFilters, action) => {
    let newFilters = Object.assign({}, filters)
    if (action.type === 'FILTER_SELECTED') {
        const orderedFilterGroups = [
            "myItem",
            "myRequest",
            "status",
            "skipValidationOffers",
            "location",
            "job",
        ];
        const groupKey = orderedFilterGroups[action.payload.parentCategory];
      
        let filterIndex = newFilters[groupKey].filters.findIndex(x => x.id === action.payload.id);
        newFilters[groupKey].filters[filterIndex].checked = !newFilters[groupKey].filters[filterIndex].checked;
    }
    if (action.type === 'UPDATE_FILTERS_LIST') {
        newFilters = Object.assign({}, filters, {
            myRequest: {
                filters: action.payload.filterDefinition
            },
            myItem: {
                filters: initFilters.myItem.filters.concat(action.payload.availableFilterDefinition)
            },
            location: { ...initFilters.location, ...action.payload.locationFilterDefinition },
            job: { ...initFilters.job, ...action.payload.jobFilterDefinition },
            skipValidationOffers: {
                filters: action.payload.skipValidationOffers.filters || [],
            },
        });
    }
    
    if (action.type === 'UPDATE_LOCATION_FILTERS_LIST') {
        newFilters = Object.assign({}, filters, {
            location: { ...action.payload },
        })
    }

    if (action.type === 'UPDATE_JOB_FILTERS_LIST') {
        newFilters = Object.assign({}, filters, {
            job: { ...action.payload },
        })
    }
    return newFilters
};

const selectedShifts = (selectedShifts = [], action) => {
    if (action.type === 'SHIFT_SELECTED') {
        if (!selectedShifts.find(shift => shift.id === action.payload.id)) {
            selectedShifts = [action.payload, ...selectedShifts]
        }
        else {
            selectedShifts = selectedShifts.filter(shift => shift.id !== action.payload.id)
        }
    }
    else if (action.type === 'CLEAR_SHIFTS') {
        selectedShifts = [];
    }
    else if (action.type === 'CLOSE_SIDE_PANEL') {
        selectedShifts = [];
    }
    return selectedShifts
}

const selectedOpenShifts = (selectedOpenShifts = [], action) => {
    if (action.type === 'OPENSHIFT_SELECTED') {
        if (!selectedOpenShifts.find(shift => shift.key === action.payload.key
            && shift.managerSettingId === action.payload.managerSettingId)) {
            return Object.assign([], [action.payload, ...selectedOpenShifts])
        }
        else {
            return Object.assign([], selectedOpenShifts.filter(shift => shift.key !== action.payload.key))
        }
    }
    else if (action.type === 'CLEAR_OPENSHIFTS') {
        return []
    }
    return selectedOpenShifts
}

const statusDictionaryReducer = () => {
    return {
        0: {
            value: 'Offered',
            color: '#b68cdb'
        },
        1: {
            value: 'Submitted',
            color: '#9159c2'
        },
        2: {
            value: 'Approved',
            color: '#07ad34'
        },
        3: {
            value: 'Refused',
            color: '#ff4040'
        },
        4: { // Offer Retracted
            value: 'Retracted',
            color: '#8a37d4'
        },
        5: { // Request Retracted
            value: 'Retracted',
            color: '#8a37d4'
        },
        6: {
            value: 'Expired',
            color: '#ff572e'
        },
        7: {
            value: 'Pending',
            color: '#fff000'
        },
        8: {
            value: 'Declined',
            color: '#ff4040'
        },
        9: {
            value: 'Auto-retracted',
            color: '#8a37d4'
        },
        10: {
            value: 'Retracted',
            color: '#8a37d4'
        }
    }
}

const managerSettingReducer = (managerSettings = [], action) => {
    if (action.type === 'APPEND_MANAGER_SETTINGS') {
        return [...managerSettings, ...action.payload]
    }
    if (action.type === 'CLEAR_MANAGER_SETTINGS') {
        return []
    }
    return managerSettings
}


const managerSettingNamesReducer = (managerSettingNames = {}, action) => {
    if (action.type === 'APPEND_MANAGER_SETTINGS') {
        let hashManagerSettingNames = {};
        for (const managerSetting of action.payload) {
            hashManagerSettingNames[managerSetting.id] = managerSetting.name;
        }
        return {...managerSettingNames, ...hashManagerSettingNames}
    }
    return managerSettingNames
}

const TimeOffRequestSubtypesReducer = (subtypes = [], action) => {
    if (action.type === 'UPDATE_TOR_SUBTYPES') {
        return Object.assign([], action.payload)
    }
    return subtypes
}

const dataReducer = (data = initData, action) => {
    if (action.type === 'UPDATE_EMPLOYEE_DASHBOARD_DATA') {
        return Object.assign({}, data, action.payload)
    }
    return data
}

const loadingReducer = (loading = true, action) => {
    if (action.type === 'UPDATE_LOADING') {
        return action.payload;
    }
    return loading
}
const privateEmployeeValidationLoadingReducer = (loading = true, action) => {
    if (action.type === 'UPDATE_LOADING_PRIVATE_EMPLOYEE_VALIDATION') {
        return action.payload;
    }
    return loading
}
const privateEmployeeNamesLoadingReducer = (loading = true, action) => {
    if (action.type === 'UPDATE_LOADING_PRIVATE_EMPLOYEE_NAMES') {
        return action.payload;
    }
    return loading
}

const snackbarReducer = (snackbar = initSnackbar, action) => {
    if (action.type === 'UPDATE_SNACKBAR') {
        return Object.assign({}, snackbar, action.payload)
    }
    return snackbar
}

const personInfoReducer = (personInfo = initPersonInfo, action) => {
    if (action.type === 'UPDATE_PERSON') {
        return Object.assign({}, action.payload)
    }
    return personInfo
}

const dateRangeReducer = (dateRange = initDateRange, action) => {
    if (action.type === 'UPDATE_DATE_RANGE') {
        return Object.assign({}, action.payload)
    }
    return dateRange
}

const sidePanelReducer = (openSidePanel = false, action) => {
    switch (action.type) {
        case 'CLOSE_SIDE_PANEL':
            return false
        case 'TOGGLE_SIDE_PANEL':
            return !openSidePanel
        case 'UPDATE_SIDE_PANEL_DATA':
            return true
        default:
            return openSidePanel
    }
}

const sidePanelDataReducer = (sidePanelData = { label: '' }, action) => {
    switch (action.type) {
        case 'CLOSE_SIDE_PANEL':
            return { label: '' }
        case 'UPDATE_SIDE_PANEL_DATA':
            return { ...sidePanelData, ...action.payload }
        default:
            return sidePanelData
    }
}

const employeesToOfferListReducer = (employeesToOfferList = { employees: [], validatedEmployees: [] }, action) => {
    switch (action.type) {
        case 'CLOSE_SIDE_PANEL':
            return {}
        case 'UPDATE_EMPLOYEES_TO_OFFER_LIST':
            return { ...action.payload }
        case 'RESET_AND_ADD_EMPLOYEES_TO_EMPLOYEES_TO_OFFER_LIST':
            return { ...employeesToOfferList, employees: [...action.payload] }
        case 'ADD_OR_UPDATE_EMPLOYEES_IN_EMPLOYEES_TO_OFFER_LIST': {
            const repeats = _.intersectionBy(action.payload, employeesToOfferList.employees, 'employeeId');
            return { ...employeesToOfferList, employees:  _.uniqBy([...repeats, ...employeesToOfferList.employees, ...action.payload], 'employeeId') }}
        case 'UPDATE_EMPLOYEES_IN_EMPLOYEES_TO_OFFER_LIST': {
            const updatedList = _.map(employeesToOfferList.employees, (employee) => {
                const updatedEmployee = _.find(action.payload, {employeeId: employee.employeeId})
                return updatedEmployee ? updatedEmployee : employee;
            });
            return { ...employeesToOfferList, employees: updatedList }}
        case 'ADD_OR_UPDATE_VALIDATED_EMPLOYEES_IN_EMPLOYEES_TO_OFFER_LIST': {
            // Add diff
            const idsToAddOrUpdate = action.payload.map(x => x.employeeId);
            const existingIds = employeesToOfferList.employees.map(x => x.employeeId);
            let updatedList = [...employeesToOfferList.employees, ...action.payload.filter(x => !existingIds.includes(x.employeeId))];
            
            // Update existing
            updatedList = _.map(updatedList, (employee) => {
                const updatedEmployee = _.find(action.payload, {employeeId: employee.employeeId})
                return updatedEmployee ? updatedEmployee : employee;
            });
            return { ...employeesToOfferList, validatedEmployees: updatedList }
        }
        case 'RESET_VALIDATED_EMPLOYEES_TO_OFFER_LIST':
        case 'UPDATE_SIDE_PANEL_DATA':
            return { validatedEmployees: [], employees: [] }
        case 'RESET_EMPLOYEES_TO_OFFER_LIST':
            return { ...employeesToOfferList, employees: [] }
        default:
            return employeesToOfferList
    }
}

const proposableShiftsPerEmployeeReducer = (proposableShiftsPerEmployee = {}, action) => {
    switch (action.type) {
        case 'CLEAR_OFFER_FORM':
        case 'CLOSE_SIDE_PANEL':
            return {}
        case 'ADD_PRIVATE_EMPLOYEE_SHIFT_TO_PROPOSE_LIST':
            return { ...proposableShiftsPerEmployee, ...action.payload }
        default:
            return proposableShiftsPerEmployee;
    }
}
const selectedProposableShiftsByOfferorReducer = (selectedProposableShiftsByOfferor = { employee: { employeeId: 0, firstName: '', lastName: '' }, shifts: [] }, action) => {
    switch (action.type) {
        case 'CLOSE_SIDE_PANEL':
        case 'CLEAR_OFFER_FORM':
        case 'RESET_PROPOSABLE_SHIFTS_BY_OFFEROR':
            return { employee: { employeeId: 0, firstName: '', lastName: '' }, shifts: [] };
        case 'SELECT_PROPOSABLE_PRIVATE_EMPLOYEE':
            return { ...selectedProposableShiftsByOfferor, employee: { ...action.payload } };
        case 'UPDATE_CHECKED_PROPOSABLE_SHIFT':
            return { ...selectedProposableShiftsByOfferor, shifts: action.payload };
        default:
            return selectedProposableShiftsByOfferor;
    }
}

const selectedActionIndexReducer = (selectedActionIndex = -1, action) => {
    switch (action.type) {
        case 'CLOSE_SIDE_PANEL':
            return -1
        case 'UPDATE_ACTION_INDEX':
            return action.payload
        default:
            return selectedActionIndex
    }
}

const validProposalShiftsReducer = (validProposalShifts = [], action) => {
    switch (action.type) {
        case 'UPDATE_VALID_PROPOSAL_SHIFTS':
            return [...action.payload]
        default:
            return validProposalShifts
    }
}

const signalRConnectionReducer = (connection = null, action) => {
    switch (action.type) {
        case 'SET_SIGNALR_CONNECTION':
            return action.payload
        default:
            return connection
    }
}

const partialDatesReducer = (partialDates = initPartialDates, action) => {

    switch (action.type) {
        case 'UPDATE_SIDE_PANEL_DATA':
            if (action.payload && action.payload.shifts) {

                const shift = action.payload.shifts[0];
                const startDate = moment.utc(shift.startDateTime);
                const endDate = moment.utc(shift.endDateTime);
                const requestType = action.payload.type || 0;
                const partialShiftLabel = generateSelectedPartialLabel(shift, startDate, endDate, requestType)

                return {
                    startDate: startDate,
                    endDate: endDate,
                    partialShiftLabel: partialShiftLabel
                }
            } else if (action.payload && action.payload.type === RequestTypes.voluntaryTimeOff && action.payload.raw) {
                // For VTO requests, use the VTO period dates
                const startDate = moment.utc(action.payload.raw.timeOffStartDate);
                const endDate = moment.utc(action.payload.raw.timeOffEndDate);
                const requestType = action.payload.type;
                const partialShiftLabel = generateSelectedPartialLabel(
                    { startDateTime: action.payload.raw.timeOffStartDate, endDateTime: action.payload.raw.timeOffEndDate },
                    startDate,
                    endDate,
                    requestType
                );

                return {
                    startDate: startDate,
                    endDate: endDate,
                    partialShiftLabel: partialShiftLabel
                }
            }

            return partialDates;
        case 'UPDATE_PARTIAL_DATES':
            return { ...action.payload };
        default:
            return partialDates;
    }

}
const proposalPartialDatesReducer = (partialDates = initPartialDates, action) => {

    switch (action.type) {
        case 'UPDATE_PROPOSAL_PARTIAL_DATES':
            return { ...action.payload };
        default:
            return partialDates;
    }

}

const refreshedDatesReducer = (refreshedDates = [], action) => {
    switch (action.type) {
        case 'UPDATE_REFRESHED_DATES':
            return action.payload;
        default:
            return refreshedDates;
    }
}

const globalConfigsReducer = (globalConfigs = initGlobalConfigs, action) => {
    if (action.type === 'UPDATE_GLOBAL_CONFIGS') {
        return Object.assign({}, action.payload)
    }
    return globalConfigs
}

const buildInfosReducer = (buildInfos = initBuildInfos, action) => {
    if (action.type === 'UPDATE_BUILD_INFOS') {
        return Object.assign({}, action.payload)
    }
    return buildInfos
}

export const dismissNotificationDataReducer = (data = initDismissData, action) => {
    if (action.type === 'UPDATE_DISMISS_NOTIFICATION_DATA') {
        return {...data, ...action.payload }
    }

    if (action.type === 'RESET_DISMISS_NOTIFICATION_DATA') {
        return initDismissData;
    }
    return data
}

const employeeDashboardReducers = {
    calendar: calendarReducer,
    data: dataReducer,
    dateRanges: dateRangeReducer,
    employeesToOfferList: employeesToOfferListReducer,
    filters: filtersReducer,
    globalConfigs: globalConfigsReducer,
    buildInfos: buildInfosReducer,
    loadingState: loadingReducer,
    privateEmployeeValidationLoadingState: privateEmployeeValidationLoadingReducer,
    privateEmployeeNamesLoadingState: privateEmployeeNamesLoadingReducer,
    managerSettingNames: managerSettingNamesReducer,
    managerSettings: managerSettingReducer,
    timeOffRequestSubtypes: TimeOffRequestSubtypesReducer,
    mobileOfferShiftForm: mobileOfferShiftFormReducer,
    mobilePaycodeForm: mobilePaycodeFormReducer,
    mobileProposalShiftsSelected: mobileProposalShiftsReducer,
    mobileView: mobileViewReducer,
    openSidePanel: sidePanelReducer,
    partialDates: partialDatesReducer,
    proposalPartialDates: proposalPartialDatesReducer,
    person: personInfoReducer,
    proposableShiftsPerEmployee: proposableShiftsPerEmployeeReducer,
    refreshedDates: refreshedDatesReducer,
    selectedActionIndex: selectedActionIndexReducer,
    selectedOpenShifts: selectedOpenShifts,
    selectedProposableShiftsByOfferor: selectedProposableShiftsByOfferorReducer,
    selectedShifts: selectedShifts,
    sidePanelData: sidePanelDataReducer,
    snackbar: snackbarReducer,
    statusDictionary: statusDictionaryReducer,
    validProposalShifts: validProposalShiftsReducer,
    dismissNotificationData: dismissNotificationDataReducer,
    signalRConnection: signalRConnectionReducer,
};

export default employeeDashboardReducers;
